import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { RECOMMNDATION_SERVICE_METHOD } from "services/commonService";
import { setInitialWizardTaken } from "utils/SharedUtils";
import { OnboardingState } from "./Onboarding";

const SLICE = "OnboardingQueries";

const initialState: OnboardingState = {
  onboardingResponse: {},
  isOnboardingCompleted: true,
  showOnboardingWizard: true,
  showOnboardingWizardFromLibrary: false,
  showWizardLoader: false,
  initialWizard: false,
  isOnboardingCheckApiCompleted: false,
  isRetakeWizard: false
};

export const fetchOnboardingQueries = createAsyncThunk(`${SLICE}/fetchOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizards, {}, thunkApi, [data.wizardType], data?.payload);
});

export const fetchOnboardingQueriesCheck = createAsyncThunk(
  `${SLICE}/fetchOnboardingQueriesCheck`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizardsCheck, {}, thunkApi)
);

export const updateOnboardingQueries = createAsyncThunk(`${SLICE}/updateOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.putWizardsResponse, data.payload, thunkApi);
});

export const OnboardingSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    setShowOnboardingWizard: (state, action) => {
      state.showOnboardingWizard = action.payload;
    },
    setShowOnboardingWizardFromLibrary: (state, action) => {
      state.showOnboardingWizardFromLibrary = action.payload;
    },
    setInitialWizard: (state, action) => {
      state.initialWizard = action.payload;
    },
    resetOnBoardingDetails: (state, action) => {
      state.isOnboardingCompleted = true;
    },
    setIsRetakeWizard: (state, action) => {
      state.isRetakeWizard = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingQueries.pending, (state) => {
        state.showWizardLoader = true;
      })
      .addCase(fetchOnboardingQueries.fulfilled, (state, action) => {
        state.showWizardLoader = false;
        const { status, ...payload } = action.payload;
        state.onboardingResponse = payload;
      })
      .addCase(fetchOnboardingQueries.rejected, (state) => {
        state.showWizardLoader = false;
      })
      .addCase(fetchOnboardingQueriesCheck.fulfilled, (state, action) => {
        state.initialWizard = !!action.payload?.createdDate;
        if (!!action.payload?.createdDate) setInitialWizardTaken();
        if (action.payload?.errors) {
          state.isOnboardingCompleted = true;
        } else {
          state.isOnboardingCompleted = !!action.payload?.createdDate;
        }
        state.isOnboardingCheckApiCompleted = true;
      })
      .addCase(fetchOnboardingQueriesCheck.rejected, (state) => {
        state.isOnboardingCompleted = true;
        state.isOnboardingCheckApiCompleted = true;
      })
      .addCase(updateOnboardingQueries.fulfilled, (state, action) => {
        state.isOnboardingCompleted = !!action.payload.createdDate;
      });
  }
});

export const {
  setShowOnboardingWizard,
  setShowOnboardingWizardFromLibrary,
  setInitialWizard,
  resetOnBoardingDetails,
  setIsRetakeWizard
} = OnboardingSlice.actions;

export default OnboardingSlice.reducer;
